import { AxiosError, AxiosResponse } from 'axios';
import { DefaultOtpType } from '../../api/user/model';
import { POST_GENERATE_OTP_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Request & Response Model
// =============================================================================
interface OtpGenerateRequest {
  resend: boolean;
  otpType: DefaultOtpType;
}

export interface OtpGenerateResponse {
  email: {
    emailAddress: string;
    resendTime: number;
  };
  sms: {
    contactNumber: string;
    resendTime: number;
  };
  defaultOtpType: DefaultOtpType;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: AxiosResponse<OtpGenerateResponse>) => void;
  onError?: (error: AxiosError) => void;
}

export const usePostGenerateOtp = ({ onSuccess, onError }: Input) => {
  const postGenerateOtp = async (data: OtpGenerateRequest) => {
    const res = await axiosClient.post<OtpGenerateResponse>(POST_GENERATE_OTP_URL, data);

    return res;
  };

  return useCustomMutation(
    postGenerateOtp,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
